<div class="codWrapper" [@leave] [@enter]>
    <app-banner></app-banner>
    <!-- <app-image-comparison></app-image-comparison> -->
    <app-upfront-payment-slider #UpfrontPaymentSliderComponent></app-upfront-payment-slider>
    <app-logistics-features></app-logistics-features>
    <app-all-plateforms></app-all-plateforms>
    <app-why-postex></app-why-postex>
   <!--  <app-our-partners></app-our-partners> -->
    <app-waiting-for ></app-waiting-for >
</div>